// extracted by mini-css-extract-plugin
export const serviceRows = "ServiceRows-module--service-rows--3IU-G";
export const rows = "ServiceRows-module--rows--2tuwS";
export const withReadMore = "ServiceRows-module--with-read-more--1GXgr";
export const expanded = "ServiceRows-module--expanded--7g7Wr";
export const readMoreButtonContainer = "ServiceRows-module--read-more-button-container--egGQu";
export const readMoreButton = "ServiceRows-module--read-more-button--3HO_I";